"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInStockList = void 0;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var selectors_1 = require("../redux/selectors");
var filterSlice_1 = require("../redux/slice/filterSlice");
var useInStockList = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var searchParams = (0, react_router_dom_1.useSearchParams)()[0];
    var _a = react_1.default.useState(false), visibleMore = _a[0], setVisibleMore = _a[1];
    var _b = (0, react_redux_1.useSelector)(selectors_1.inStockListSelector), inStockList = _b.inStockList, _c = _b.stateLoad, error = _c.error, isLoad = _c.isLoad;
    var isLoadCars = (0, react_redux_1.useSelector)(selectors_1.carsSelector).isLoading;
    var isSmall = (0, react_redux_1.useSelector)(selectors_1.mediaQuerySelector).isSmall;
    var params = {
        brandParam: searchParams.get('brand_name'),
        modelParam: searchParams.get('model_name'),
        generationParam: searchParams.get('generation_name'),
    };
    var handlers = react_1.default.useMemo(function () { return ({
        handleMoreButton: function () { return setVisibleMore(function (prev) { return !prev; }); },
        handleBrandClick: function (brandName) {
            dispatch((0, filterSlice_1.setFilterValue)({ key: 'brand_name', value: brandName }));
            dispatch((0, filterSlice_1.loadFilters)({ brand_name: brandName }));
            navigate("/cars?brand_name=".concat(brandName));
        },
        handleModelClick: function (brandName, modelName) {
            dispatch((0, filterSlice_1.setFilterValue)({ key: 'model_name', value: modelName }));
            dispatch((0, filterSlice_1.loadFilters)({
                brand_name: brandName,
                model_name: modelName,
            }));
            navigate("/cars?brand_name=".concat(brandName, "&model_name=").concat(modelName));
        },
        handleGenerationClick: function (brandName, modelName, generationName) {
            dispatch((0, filterSlice_1.setFilterValue)({ key: 'generation_name', value: generationName }));
            dispatch((0, filterSlice_1.loadFilters)({
                brand_name: brandName,
                model_name: modelName,
                generation_name: generationName,
            }));
            navigate("/cars?brand_name=".concat(brandName, "&model_name=").concat(modelName, "&generation=").concat(generationName));
        },
    }); }, [dispatch, navigate]);
    var listData = react_1.default.useMemo(function () {
        var _a;
        var brandParam = params.brandParam, modelParam = params.modelParam;
        var currentBrand = brandParam ? inStockList.find(function (item) { return item.brand === brandParam; }) : null;
        var currentModels = currentBrand === null || currentBrand === void 0 ? void 0 : currentBrand.models;
        var currentGenerations = (_a = currentBrand === null || currentBrand === void 0 ? void 0 : currentBrand.models.find(function (model) { return model.name === modelParam; })) === null || _a === void 0 ? void 0 : _a.generations;
        var visibleItems = visibleMore ? inStockList : inStockList.slice(0, isSmall ? 18 : 24);
        return {
            inStockList: inStockList,
            currentModels: currentModels,
            currentGenerations: currentGenerations,
            visibleItems: visibleItems,
        };
    }, [inStockList, params, visibleMore, isSmall]);
    react_1.default.useEffect(function () {
        var brandParam = params.brandParam, modelParam = params.modelParam, generationParam = params.generationParam;
        if (brandParam) {
            dispatch((0, filterSlice_1.setFilterValue)({ key: 'brand_name', value: brandParam }));
        }
        if (modelParam) {
            dispatch((0, filterSlice_1.setFilterValue)({ key: 'model_name', value: modelParam }));
        }
        if (generationParam) {
            dispatch((0, filterSlice_1.setFilterValue)({ key: 'generation_name', value: generationParam }));
        }
    }, [dispatch, params]);
    return {
        isLoading: isLoad || isLoadCars,
        error: error,
        visibleMore: visibleMore,
        listData: listData,
        params: params,
        handlers: handlers,
    };
};
exports.useInStockList = useInStockList;
